/* ============================================================
   Barra de envio gratis del cart drawer.
   Escucha cart:updated (el evento propio del tema) y repinta.
   Los importes se formatean con toLocaleString('es-MX'), no con
   shop.money_format, por pedido del brief.
   ============================================================ */

(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function texts() {
    var el = document.querySelector('[data-csb-i18n]');
    if (!el) {
      return { progress: 'Te faltan [monto] para envio gratis', reached: 'Tienes envio gratis' };
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { progress: 'Te faltan [monto] para envio gratis', reached: 'Tienes envio gratis' };
    }
  }

  function paint(total) {
    var bars = document.querySelectorAll('[data-csb]');
    if (!bars.length) {
      return;
    }
    var t = texts();

    Array.prototype.forEach.call(bars, function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold) {
        return;
      }
      var remaining = threshold - total;
      var pct = Math.min(100, (total / threshold) * 100);

      var textEl = bar.querySelector('[data-csb-text]');
      var fill = bar.querySelector('[data-csb-fill]');

      if (textEl) {
        textEl.textContent = remaining > 0
          ? String(t.progress).replace('[monto]', money(remaining))
          : t.reached;
      }
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('is-full', remaining <= 0);
      }
      bar.querySelectorAll('[role="progressbar"]').forEach(function (p) {
        p.setAttribute('aria-valuenow', Math.round(pct));
      });
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart.total_price); })
      .catch(function () { /* sin red dejamos el estado pintado por Liquid */ });
  }

  /* El tema emite estos dos al cambiar el carrito. */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      paint(e.detail.cart.total_price);
    } else {
      refresh();
    }
  });

  document.addEventListener('cart:build', refresh);
})();
